<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-04-30 20:59:55
 * @LastEditors: ???
 * @LastEditTime: 2022-05-28 22:27:10
-->
<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-button size="mini" type="primary" @click="handleAdd()"
            >新增</el-button
          >
          <!-- <el-button type="danger" @click="batchDel">批量删除</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #statusSlot="slotData">
        <span>{{ slotData.data.row.status | dataStatus }}</span>
      </template>

      <template #handlerSlot="slotData">
        <el-button size="mini" @click="handleEdit(slotData.data.row)"
          >修改</el-button
        >
        <el-button
          type="danger"
          size="mini"
          @click="handleDelete(slotData.data.row.id)"
          >删除</el-button
        >
      </template>
    </e-table>

    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
  </div>
</template>

<script>
import modalForm from './component/streetAddModal';
import eTable from '@/components/table';
import { listMixin } from '@/mixins/listMixin';
export default {
  components: { eTable, modalForm },
  mixins: [listMixin],
  props: {},
  data() {
    return {
      deleteKey: 'id',
      url: {
        list: '/wlStreet/listByPage',
        delete: '/wlStreet/delete',
        deleteBatch: 'userManager/deleteById',
      },

      //字段权限
      columns: [
        { field: 'name', label: '社区名称' },

        // { field: 'createBy', label: '创建人' },
        { field: 'createTime', label: '创建时间' },

        // {
        //   field: 'updateBy',
        //   label: '更新人',
        // },
        // {
        //   label: '状态',
        //   slotName: 'statusSlot',
        //   columnType: 'slot',
        // },

        {
          width: 260,
          label: '编辑',
          slotName: 'handlerSlot',
          columnType: 'slot',
        },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    fetchData() {
      console.log(this.ipagination.page);
    },
    add(val) {
      console.log(val);
    },
    edit(val) {},
    del(val) {},
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
</style>
